import styled from 'styled-components';

export const NotificationsWrapper = styled.div`
  color: ${(props: any) => props.theme.carvana.blue.dark};
  margin: ${(props: any) => props.margin};
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 36px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    margin-bottom: 40px;
  }
`;

export const HeaderAlt = styled.div`
  display: flex;
`;

export const TitleWrapper = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  margin-bottom: 9px;
  text-transform: uppercase;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    font-size: 20px;
    line-height: 24px;
    margin-bottom: 10px;
  }
`;

export const Subtitle = styled.div`
  font-size: 16px;
  line-height: 16px;
  font-weight: 450;

  &.has-bottom-margin {
    margin-bottom: 8px;

    @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
      margin-bottom: 8 px;
    }
  }
`;

export const EditLink = styled.a`
  font-size: 12px;
  line-height: 12px;
  font-weight: 700;
  color: ${(props: any) => props.theme.carvana.blue.primary};
  text-transform: uppercase;
  :hover {
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
`;

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props: any) => props.theme.carvana.gray.dark};

  &.title-description {
    padding-right: 15px;
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const SubDescription = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${(props: any) => props.theme.carvana.gray.dark};
  padding: 16px 0 32px;

  &.title-description {
    padding-right: 15px;
  }

  a {
    color: ${(props: any) => props.theme.carvana.blue.primary};
    &:hover {
      color: ${(props: any) => props.theme.carvana.blue.hover};
    }
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    font-size: 12px;
  }
`;

export const Options = styled.div`
  margin-bottom: 44px;
`;

export const BottomBorder = styled.div`
  border-bottom: 1px solid ${(props: any) => props.theme.carvana.gray.light};
  margin-bottom: 40px;

  &.last-border {
    margin-bottom: 10px;
  }
`;

export const Option = styled.div`
  display: flex;
  margin-bottom: 34px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    margin-bottom: 38px;
  }

  &.no-description {
    margin-bottom: 25px;
  }
`;

export const OptionTitleWrapper = styled.div`
  flex: 1;
  padding-right: 30px;
`;

export const OptionTitle = styled.div`
  font-size: 16px;
  line-height: 26px;
  font-weight: 700;
  margin-bottom: 5px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 13px;
  }
`;

export const CheckboxWrapper = styled.div`
  width: 45px;
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const UnsubscribeFromAll = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 6px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    padding-top: 0px;
    justify-content: flex-end;
  }
`;

export const UnsubText = styled.span`
  font-size: 10px;
  line-height: 10px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${(props: any) => props.theme.carvana.blue.dark};
  margin-right: 11px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    font-size: 12px;
    line-height: 12px;
  }

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.md}px) {
    font-size: 14px;
    line-height: 14px;
  }
`;
